import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import React, { useCallback, useMemo } from 'react';
import { Flex, GridAlpha } from '@applyboard/crystal-ui';
import { useScholarshipPageContext } from "../../contexts";
import { PageSectionTitle } from "../PageSectionTitle";
import { ScholarshipCard } from "../ScholarshipCard/index";
import { useScholarships } from "../../../../data/useScholarships";
import { removeScholarshipDescription } from "../utils";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var OtherScholarships = function OtherScholarships(_ref) {
  var schoolGroupId = _ref.schoolGroupId;
  var _useScholarshipPageCo = useScholarshipPageContext(),
    scholarship = _useScholarshipPageCo.scholarship;
  var _useScholarships = useScholarships('schoolGroupId', (schoolGroupId === null || schoolGroupId === void 0 ? void 0 : schoolGroupId.toString()) || ''),
    schoolGroupScholarships = _useScholarships.data;
  var otherScholarships = useMemo(function () {
    return schoolGroupScholarships.filter(function (s) {
      return s.id !== (scholarship === null || scholarship === void 0 ? void 0 : scholarship.id);
    });
  }, [schoolGroupScholarships, scholarship]);
  var getCardEventTrackingData = useCallback(function (scholarship) {
    return {
      pageScholarship: removeScholarshipDescription(scholarship),
      pageOtherScholarships: otherScholarships.map(removeScholarshipDescription),
      cardScholarship: removeScholarshipDescription(scholarship)
    };
  }, [otherScholarships]);
  if (otherScholarships.length === 0) {
    return null;
  }
  return _jsxs(Flex, {
    direction: "column",
    gap: 4,
    children: [_jsx(PageSectionTitle, {
      title: "Other scholarships"
    }), _jsx(GridAlpha, {
      columnGap: 4,
      columns: {
        xs: 'repeat(1, 12fr)',
        sm: 'repeat(2, 6fr)',
        md: 'repeat(3, 4fr)'
      },
      rowGap: 6,
      children: otherScholarships.map(function (scholarship) {
        return _jsx(GridAlpha.Item, {
          children: _jsx(ScholarshipCard, {
            scholarship: scholarship,
            eventTrackingOptions: {
              eventsPrefix: 'Scholarship Page - ',
              eventTrackingData: getCardEventTrackingData(scholarship)
            }
          })
        }, scholarship.id);
      })
    })]
  });
};